import React from 'react';
import { CAN_ENROLL_IN_CONFIG_WIZARD_VIEW } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { ErrorBoundaryWithChunkErrorLogging } from '@atlassian/jira-onboarding-core/src/ui/error-boundary-with-chunk-error-logging/index.tsx';
import { sessionStorageProvider } from '@atlassian/jira-onboarding-core/src/utils/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyWelcomeModal = lazy(() =>
	import(/* webpackChunkName: "async-software-onboarding-modals-welcome-modal" */ './index').then(
		({ WelcomeModal }) => WelcomeModal,
	),
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyWelcomeModalWizard = lazy(() =>
	import(
		/* webpackChunkName: "async-software-onboarding-modals-welcome-modal-wizard" */ './wizard'
	).then(({ WelcomeModal }) => WelcomeModal),
);

export const AsyncWelcomeModal = ({ source }: Props): React.JSX.Element => {
	return (
		<UFOSegment name="async-onboarding-welcome-modal">
			<ErrorBoundaryWithChunkErrorLogging
				id="asyncWelcomeModalComponent"
				fallback="unmount"
				packageName="jiraSoftwareOnboardingModals"
				teamName="Growth-Jira-Find"
			>
				<Placeholder name="software-onboarding-modals-welcome-modal" fallback={<></>}>
					{['list', 'board'].includes(source) && // our new wizard only needs to render on list/board
					sessionStorageProvider.get(CAN_ENROLL_IN_CONFIG_WIZARD_VIEW) ? (
						<LazyWelcomeModalWizard source={source} />
					) : (
						<LazyWelcomeModal source={source} />
					)}
				</Placeholder>
			</ErrorBoundaryWithChunkErrorLogging>
		</UFOSegment>
	);
};
